module Shared.DtoTypes.PhysicalSensor

open System

type WaterDepthProbe = { Depth: int }

type PressureProbe =
    | WaterDepth of WaterDepthProbe
    | Pressure

type SensorModel =
    | LHT65
    | LSN50v2_S31
    | S31_LS
    | S31_LB
    | LSE01
    | SE01_LS
    | SE01_LB
    | LSN50v2_Rain_01mm
    | LSN50v2_Rain_02mm
    | LSN50v2_Wind
    | SN50v3_LS_Rain_01mm
    | SN50v3_LB_Rain_01mm
    | SN50v3_LS_Rain_02mm
    | SN50v3_LB_Rain_02mm
    | SN50v3_LS_Wind
    | SN50v3_LB_Wind
    | LLMS01
    | LSPH01
    | WSC1L
    | DDS20_LB
    | DDS20_LS
    | RS485_LB_ZFS_02
    | RS485_LS_ZFS_02
    | SE0X_LB
    | PS_LB of PressureProbe
    | PS_LS of PressureProbe
    | SPH01_LB
    | SPH01_LS
    | LDDS75
    | DDS75_LB
    | DDS75_LS
    | WQS_LB
    | WQS_LS

type DeviceCondition =
    | Operational
    | Defective
    | Repaired

module DeviceCondition =
    let label (condition: DeviceCondition) =
        match condition with
        | Operational -> "Funktionstüchtig"
        | Defective -> "Defekt"
        | Repaired -> "Repariert"

type PhysicalSensorBaseData = {
    Id: int
    TtnId: string
    Name: string
    DeviceEui: string
    AppEui: string
    AppKey: string
    TtsDescription: string option
    UserId: int option
    Condition: DeviceCondition
    LocationId: int option
    MaxHumidity: float option
    Note: string option
}

let createPhysicalSensorBaseData
    id
    ttnId
    name
    deviceEui
    appEui
    appKey
    description
    userId
    condition
    locationId
    maxHumidity
    note
    =
    {
        Id = id
        TtnId = ttnId
        Name = name
        DeviceEui = deviceEui
        AppEui = appEui
        AppKey = appKey
        TtsDescription = description
        UserId = userId
        MaxHumidity = maxHumidity
        Condition = condition
        LocationId = locationId
        Note = note
    }

type ConfiguredPhysicalSensor = {
    BaseData: PhysicalSensorBaseData
    Configuration: SensorModel
}

type PhysicalSensor =
    | Configured of ConfiguredPhysicalSensor
    | UnConfigured of PhysicalSensorBaseData

type AdjustedHumidity = {
    OriginalHumidity: float
    AdjustedHumidity: float
    UnboundedAdjustedHumidity: float
    MaxHumidity: float
}

type AirHumidity =
    | Original of float
    | Adjusted of AdjustedHumidity

[<RequireQualifiedAccess>]
module AirHumidity =
    let getHumidityPercentage (humidity: AirHumidity) =
        match humidity with
        | Original humidity -> humidity
        | Adjusted humidity -> humidity.AdjustedHumidity

type PhysicalSensorLastData = {
    LastTimeStamp: DateTimeOffset
    LastTimespan: TimeSpan option
    LastSpreadingFactor: int
    LastHumidity: AirHumidity option
}

type PhysicalSensorWithLastData = {
    Sensor: PhysicalSensor
    LastData: PhysicalSensorLastData option
}